import React, { useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";
import Countdown from "../CountDown";
import TimerUp from "../TimerUP";
import "./TodoList.css";

const INITIAL_TASKS = [
  { id: "1", title: "Plan the week" },
  { id: "2", title: "Reply to important emails" },
  { id: "3", title: "Take a 20-minute walk" }
];

const TodoList = () => {
  const [taskTitle, setTaskTitle] = useState("");
  const [todoList, setTodoList] = useState(INITIAL_TASKS);
  const [selectedTask, setSelectedTask] = useState("");
  const [activeMode, setActiveMode] = useState("");
  const [clock, setClock] = useState(false);
  const [showTime, setShowTime] = useState(false);
  const [mypick, setMyPick] = useState(25);

  const selectTask = (task, mode) => {
    if (!task) return;

    setSelectedTask(task.title);
    setActiveMode(mode);
    setClock(mode === "start");
    setShowTime(mode === "flow");
    setMyPick(25);
  };

  const addTodo = (event) => {
    event.preventDefault();
    const title = taskTitle.trim();

    if (!title) return;

    setTodoList((currentTasks) => [
      ...currentTasks,
      { id: `${Date.now()}-${title}`, title }
    ]);
    setTaskTitle("");
  };

  const deleteTodo = (id) => {
    setTodoList((currentTasks) => currentTasks.filter((task) => task.id !== id));
  };

  const randomTodo = () => {
    if (!todoList.length) return;
    const task = todoList[Math.floor(Math.random() * todoList.length)];
    selectTask(task, "random");
  };

  const startTodo = () => {
    selectTask(todoList[0], "start");
  };

  const flowTodo = () => {
    selectTask(todoList[0], "flow");
  };

  const refreshDemo = () => {
    setTodoList(INITIAL_TASKS);
    setTaskTitle("");
    setSelectedTask("");
    setActiveMode("");
    setClock(false);
    setShowTime(false);
    setMyPick(25);
  };

  return (
    <div className="demo-task-picker">
      <div className="demo-todo-modes" aria-label="Productivity modes">
        <button type="button" onClick={randomTodo} className="demo-mode-button demo-random-mode">
          <span className="demo-mode-icon">🎲</span>
          <span>RANDOM</span>
        </button>
        <button type="button" onClick={startTodo} className="demo-mode-button demo-start-mode">
          <span className="demo-mode-icon">▶️</span>
          <span>START</span>
        </button>
        <button type="button" onClick={flowTodo} className="demo-mode-button demo-flow-mode">
          <span className="demo-mode-icon">🌊</span>
          <span>FLOW</span>
        </button>
        <button type="button" onClick={refreshDemo} className="demo-mode-button demo-refresh-mode">
          <span className="demo-mode-icon">🔄</span>
          <span>RESET</span>
        </button>
      </div>

      {selectedTask && (
        <div className={`demo-selected-task demo-selected-${activeMode}`}>
          <span className="demo-selected-label">
            {activeMode === "random" ? "Today's Main Task" : activeMode === "start" ? "Pomodoro Task" : "Flow Task"}
          </span>
          <h2>{selectedTask}</h2>
          {clock && <Countdown until={mypick} label="25 minute focus" />}
          {showTime && <TimerUp running />}
        </div>
      )}

      <form className="demo-todo-form" onSubmit={addTodo}>
        <label htmlFor="demo-task-title">Add a task to try it yourself</label>
        <div>
          <input
            id="demo-task-title"
            type="text"
            value={taskTitle}
            onChange={(event) => setTaskTitle(event.target.value)}
            placeholder="e.g. Draft the project outline"
          />
          <button type="submit">
            <FaPlus />
            Add Task
          </button>
        </div>
      </form>

      <div className="demo-todo-items">
        <h2>Your Demo Tasks</h2>
        {todoList.length === 0 ? (
          <p className="demo-no-tasks">Add a task, then choose a mode above.</p>
        ) : (
          <ul>
            {todoList.map((todo) => (
              <li key={todo.id}>
                <span>{todo.title}</span>
                <button type="button" onClick={() => deleteTodo(todo.id)} aria-label={`Delete ${todo.title}`}>
                  <FaTrash />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default TodoList;
